// Build-time config. Only VITE_* values are exposed to the browser — and none of
// them are secrets (the Turnstile *site* key is public by design; the worker holds
// the Turnstile *secret* and the HMAC secret).
// Default: same-origin in production (worker routed at /api/* on this host);
// the local wrangler port in dev. Override with VITE_API_BASE either way.
// VITE_MOCK_API=1 (dev only) keeps API calls same-origin so the Vite dev-server
// mock (vite.config.ts) serves /api/* — used to build W6b against the rates
// contract before W6a's worker endpoint exists.
const mockApi = import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1';
const fallback = import.meta.env.DEV && !mockApi ? 'http://localhost:8787' : '';
const rawBase = (import.meta.env.VITE_API_BASE || fallback).replace(/\/+$/, '');

export const CONFIG = {
  /** Worker base URL. '' = same-origin (worker routed at /api/* on this host). */
  apiBase: rawBase,
  /**
   * Public Cloudflare Turnstile site key. The always-pass test key is a
   * DEV-only fallback; production builds without a real key are rejected
   * in vite.config.ts (an empty key would ship a widget that never gates).
   */
  turnstileSitekey:
    import.meta.env.VITE_TURNSTILE_SITEKEY ??
    (import.meta.env.DEV ? '1x00000000000000000000AA' : ''),
  locale: 'de-CH',
} as const;

export const ENDPOINTS = {
  lead: `${CONFIG.apiBase}/api/lead`,
  beratung: `${CONFIG.apiBase}/api/beratung`,
  /**
   * Public rates feed (W6a). Under /api/* so the EXISTING worker route on
   * tools.finavest.ch picks it up same-origin and the edge cache applies.
   * Contract: publicRatesSchema in @finavest/shared (mirrored in rates.ts).
   */
  rates: `${CONFIG.apiBase}/api/public/rates`,
} as const;

export const FEATURES = {
  /** W6c ships the Zins-Update backend/DOI; until then the signup UI stays off. */
  zinsupdate: import.meta.env.VITE_FEATURE_ZINSUPDATE === '1',
} as const;
